import type { PageableSort } from './pageableSort';

/**
 * Spring Data Pageable 정보
 */
export interface Pageable {
  /** 요청된 페이지 번호 */
  page?: number;
  /** 요청된 페이지 크기 */
  size?: number;
  /** Spring Data Sort 정보 */
  sort?: PageableSort;
}
